import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { DealPage } from '../../../../features/sales/ui/deal-panel.tsx';
import { requirePermissionRoute } from '../../../../lib/permissions.ts';

export const Route = createFileRoute('/_app/sales/deals/$id')({
  beforeLoad: requirePermissionRoute('sales.use'),
  component: DealRoute,
});

/** Сделка на всю страницу (⌘↵ из панели). */
function DealRoute() {
  const { id } = Route.useParams();
  const navigate = useNavigate();
  return (
    <DealPage
      id={id}
      onBack={(phase) => {
        void navigate(
          phase === 'lead'
            ? { to: '/sales/leads', search: { deal: id } }
            : { to: '/sales/pipeline', search: phase === null ? {} : { deal: id } },
        );
      }}
      onGone={() => {
        void navigate({ to: '/sales/leads', search: {} });
      }}
    />
  );
}
